/**
 * The offer, in one place.
 *
 * These strings appear on the billing card, on the analytics paywall, and (to
 * be mirrored) on the marketing site. They were scattered as inline copy
 * before, which is how a café could be told "free" in one place and shown a
 * price in another.
 *
 * The promise being made here is deliberate and load-bearing (Nik, 2026-08-12):
 * the CORE LOOP is free forever, on every plan, for everyone. Stamps, the
 * counter QR, wallet passes, the customer's card and its history — a café can
 * run its entire loyalty programme and never pay. Only the owner-facing
 * INSIGHT is chargeable.
 *
 * That line is not marketing. If a café's own customers ever hit a wall
 * because the café didn't pay, we have damaged the café's relationship with
 * its regulars, and they will leave and be right to. Do not move anything in
 * the core loop behind billing.
 *
 * Saying the price UP FRONT is the other half. A charge that arrives after
 * months of unqualified "free" reads as a bait-and-switch; the same charge
 * disclosed on day one is simply a discount being granted. Founders are told
 * their price and its start date at signup, so there is never a clawback —
 * only a date they already knew.
 */

/** When the free pilot ends and founders convert to their locked price. */
export const PILOT_ENDS = '31 March 2027';

/** Founders' price after the pilot. Locked for life — never rises. */
export const FOUNDERS_PRICE = 'A$29/mo';

/** Standard price for shops that arrive after the founding allocation. */
export const STANDARD_PRICE = 'A$69/mo';

/** The one-sentence version of the whole offer. */
export const FREE_FOREVER_LINE =
  'Run your whole loyalty programme free forever — you only pay if you want to know who your regulars are.';

/** What never costs money, on any plan. */
export const ALWAYS_FREE = 'Stamps, your counter QR, wallet passes, and your customers’ cards are free forever, on every plan.';
